import { hotRank } from "@/mocks/homeData";

const trendIcon = { up: "ri-arrow-up-line", down: "ri-arrow-down-line", new: "ri-sparkling-2-line" };
const trendColor = { up: "text-primary-600", down: "text-foreground-400", new: "text-accent-600" };

export default function TrendingSection() {
  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1.5fr] gap-6 lg:gap-10 items-stretch rounded-2xl overflow-hidden bg-background-100 border border-background-200">
          <div className="relative p-6 md:p-10 flex flex-col justify-center overflow-hidden">
            <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-accent-500/20 blur-2xl"></div>
            <div className="absolute -left-6 bottom-0 w-40 h-40 rounded-full bg-primary-500/10 blur-2xl"></div>
            <span className="relative inline-flex self-start items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold text-background-50 bg-foreground-950 whitespace-nowrap">
              <i className="ri-fire-fill text-accent-400"></i> 实时热度
            </span>
            <h2 className="relative mt-5 text-2xl md:text-4xl font-heading font-bold text-foreground-950 tracking-tight">
              今日吃瓜榜
            </h2>
            <p className="relative mt-4 text-sm leading-relaxed text-foreground-600 max-w-md">
              把此刻讨论度最高的现场与图集按热度实时排序。榜单随事件走势变化，刷新即见最新吃瓜风向。
            </p>
            <span className="relative mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 cursor-pointer whitespace-nowrap"
              onClick={() => window.dispatchEvent(new CustomEvent("chigua:toast", { detail: "榜单已按最新热度刷新完成" }))}>
              <i className="ri-refresh-line"></i> 刷新热度
            </span>
          </div>

          <ol className="grid grid-cols-1 p-4 md:p-6 gap-2">
            {hotRank.map((r, idx) => (
              <li key={r.id} className="flex items-center gap-3 md:gap-4 px-3 md:px-4 py-3 md:py-3.5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-background-100 transition cursor-pointer"
                onClick={() => window.dispatchEvent(new CustomEvent("chigua:toast", { detail: `进入热门：${r.title}` }))}>
                <span
                  className={`shrink-0 w-9 h-9 flex items-center justify-center rounded-md font-heading font-bold text-sm md:text-base ${
                    idx === 0
                      ? "bg-accent-500 text-background-50"
                      : idx === 1
                      ? "bg-primary-500 text-background-50"
                      : idx === 2
                      ? "bg-secondary-500 text-background-50"
                      : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-sm md:text-base font-semibold text-foreground-950 truncate">{r.title}</p>
                  <div className="mt-1.5 flex items-center gap-2">
                    <span className="h-1.5 flex-1 rounded-full bg-background-200 overflow-hidden">
                      <span
                        className="block h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                        style={{ width: `${r.heat}%` }}
                      ></span>
                    </span>
                    <span className="text-xs font-heading font-semibold text-foreground-500">{r.heat}</span>
                  </div>
                </div>
                <i className={`${trendIcon[r.trend]} ${trendColor[r.trend]} text-lg shrink-0`}></i>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}